import { CommonModule } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { WizardSection } from '@app/models/project-setup.models';
import { WizardStore } from '@app/stores/project-setup/wizard.store';
import { CardComponent } from '@app/ui-components/card/card.component';
import { InfoLabelComponent } from '@app/ui-components/info-label/info-label.component';
import { ValidatedTextAreaComponent } from '@app/ui-components/validated-textarea/validated-textarea.component';
import { TranslateModule } from '@ngx-translate/core';
import { SectionCFormGroup } from '../+helpers/section-c-form.helper';

@Component({
  selector: 'app-section-c',
  imports: [
    CommonModule,
    TranslateModule,
    ValidatedTextAreaComponent,
    CardComponent,
    ReactiveFormsModule,
    InfoLabelComponent,
  ],
  templateUrl: './section-c.component.html',
  styleUrl: './section-c.component.scss',
})
export class SectionCComponent implements OnInit {
  wizardStore = inject(WizardStore);
  projectId = input.required<string>();
  protected formGroup = signal<FormGroup<SectionCFormGroup> | null>(null);
  protected translationKey = 'projectWizard.sectionCForm.';

  constructor(private destroyRef: DestroyRef) {}

  ngOnInit(): void {
    this.wizardStore
      .getSection(this.projectId(), WizardSection.C)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) =>
        this.formGroup.set(data as FormGroup<SectionCFormGroup>)
      );
  }
}
